import { request } from '../../utils/request';

export type UnreadByConversation = {
  conversationId: number;
  unreadCount: number;
};

export type UnreadCountsResponse = {
  totalUnread: number;
  unreadByConversation: UnreadByConversation[];
};

export const getUnreadCounts = (
  authToken: string
): Promise<UnreadCountsResponse> =>
  request({
    method: 'GET',
    url: '/messaging/unread',
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
    callback: undefined,
    onError: (err) => {
      throw err;
    },
  });
